import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=8f758e7c&scoped=true&"
import script from "./LogsTable.vue?vue&type=script&lang=ts&"
export * from "./LogsTable.vue?vue&type=script&lang=ts&"
import style0 from "./LogsTable.vue?vue&type=style&index=0&id=8f758e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f758e7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
